import { render } from "./ChatTabsIndicator.vue?vue&type=template&id=fc27b980"
import script from "./ChatTabsIndicator.vue?vue&type=script&lang=js"
export * from "./ChatTabsIndicator.vue?vue&type=script&lang=js"

import "./ChatTabsIndicator.vue?vue&type=style&index=0&id=fc27b980&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ChatTabsIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc27b980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc27b980', __exports__)) {
    api.reload('fc27b980', __exports__)
  }
  
  module.hot.accept("./ChatTabsIndicator.vue?vue&type=template&id=fc27b980", () => {
    api.rerender('fc27b980', render)
  })

}


export default __exports__